// removed by extract-text-webpack-plugin
module.exports = {"block":"text__block-8eLMj","textfield":"text__textfield-QsmC2","isDisabled":"text__isDisabled-3x614","limit":"text__limit-2_iX2","tooltip":"text__tooltip-MDzVg","showLimit":"text__showLimit-1hooH text__textfield-QsmC2","popupMode":"text__popupMode-3BiRz","hasError":"text__hasError-1kvWK","tooltipWrapper":"text__tooltipWrapper-1Epb1","leftToRightWrapper":"text__leftToRightWrapper-wlc-4","topToBottomWrapper":"text__topToBottomWrapper-3HiCz","topToBottom":"text__topToBottom-1AMW7","leftToRight":"text__leftToRight-2BqxE"};


//////////////////
// WEBPACK FOOTER
// ./packages/account-ui/text/text.css
// module id = 874
// module chunks = 0